import styled, { css } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const SatoshiOptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 36px !important;
  max-height: 36px !important;
  min-height: 36px !important;
  gap: ${SPACING._6};
  position: relative;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const SidebarContainer = styled.div<{
  collapsed: boolean;
}>`
  background-color: ${({ theme }) => theme.neutral[950]};
  border-right: 1px solid ${({ theme }) => theme.neutral[800]};
  height: 100vh;
  transition: 200ms;
  width: ${({ collapsed }) => (collapsed ? '80px' : '272px')};
  min-width: ${({ collapsed }) => (collapsed ? '80px' : '272px')};
  padding: ${SPACING._20};
  display: flex;
  flex-direction: column;
  gap: ${SPACING._20};

  @media (max-width: 750px) {
    width: 100%;
    min-width: 100%;
    padding: ${SPACING._16};
    height: 100vh;
  }
`;

export const SidebarFooter = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: auto;

  @media (max-width: 750px) {
    margin-top: 0;
  }

  li {
    width: 100%;
  }
`;

export const FavoritesWrapper = styled.div<{
  collapsed: boolean;
}>`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  > div {
    overflow-y: auto;
    scrollbar-width: thin;
    overflow-x: hidden;

    ${({ collapsed }) =>
      collapsed &&
      css`
        /* Oculta scrollbar no Chrome, Safari e Edge */
        &::-webkit-scrollbar {
          display: none;
        }

        /* Oculta scrollbar no Firefox */
        scrollbar-width: none;

        /* Evita o espaço da scrollbar no Firefox */
        -ms-overflow-style: none; /* IE e Edge antigo */
      `}
  }

  ${({ collapsed }) =>
    collapsed &&
    css`
      /* Oculta o scrollbar no Chrome, Edge e Safari */
      &::-webkit-scrollbar {
        display: none;
      }

      /* Oculta o scrollbar no Firefox */
      scrollbar-width: none; /* Firefox */

      /* Evita quebra de layout */
      -ms-overflow-style: none; /* Internet Explorer e Edge Legacy */
    `}
`;
